// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"223":"d085792e","745":"c051b5ee","795":"2a9603c8","850":"c051b5ee"}[chunkId] + ".chunk.css";
};